import React, { ReactElement } from "react";

import CheckPermissions from "../../CheckPermissions";

import { COMPONENTS } from "@utils/Constants";

export const BundleAnalysisLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: BundleAnalysis } = await import("@workflows/bundles/analysis/BundleAnalysis");
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.BUNDLES_ANALYSIS}>
      <BundleAnalysis />
    </CheckPermissions>
  );
  return { Component: WrappedRules };
};
